import axios from '../utils/axios'
/**
 * 获取活动列表
 * @param {*} token
 * @param {*} topicId
 * @returns
 */
 export const getTopicList = (token, topicId) => {
    return new Promise((resolve, reject) => {
      let url = '/api/blade-content/component';
      axios.defaults.headers.common['Blade-Auth'] = token;
      axios({
        headers:{
          'Content-Type':'application/x-www-form-urlencoded',
        },
        url:url,
        method:"get",
        params: {
            topicId:topicId
          }
      })
      .then((res)=>{
        resolve(res.data)
      })
      .catch((err)=>{
        reject(err)
      })
    })
  }


  // 购物车手动领取优惠券  /blade-coupon/coupon/baseInfo/receiveCoupon    couponId    get
export const GetCoupon=(token, couponId)=>{
  return new Promise((resolve,reject)=>{
      let url ='/api/blade-coupon/coupon/baseInfo/receiveCoupon';
      axios.defaults.headers.common['Blade-Auth'] = token;
      axios.get(url,{
          //请求头配置  
          headers:{  'Content-Type':'application/x-www-form-urlencoded'},
         //参数列表
         params:{id:couponId},
        
     })
      .then((data)=>{
          var result = data;
          return resolve(result)
      })
      .catch((err)=>{
          reject(err)
      })
  })
}




// WEBPACK FOOTER //
// ./src/api/topicPage.js